import type React from 'react';

interface TurkeyIconProps {
	className?: string;
	size?: number;
}

export const TurkeyIcon: React.FC<TurkeyIconProps> = ({
	className = '',
	size = 24,
}) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox='0 0 3.84 3.84'
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			aria-hidden='true'
			role='img'
			className={className}
			preserveAspectRatio='xMidYMid meet'
		>
			<path
				d='M1.362 2.971s0.017 0.215 0 0.241 -0.144 0.038 -0.241 0.131c-0.08 0.076 -0.063 0.165 0.03 0.156s0.199 -0.093 0.313 -0.114 0.287 -0.008 0.287 -0.08 -0.152 -0.089 -0.152 -0.089v-0.207l0.194 0.017 -0.008 0.355s-0.211 0.076 -0.275 0.127 -0.118 0.131 -0.072 0.177 0.152 -0.017 0.199 -0.03c0.046 -0.013 0.19 -0.08 0.291 -0.093 0.101 -0.013 0.287 0.013 0.308 -0.038 0.021 -0.051 -0.038 -0.106 -0.118 -0.131l-0.08 -0.025V2.95z'
				fill='#858585'
			/>
			<path
				d='M1.421 1.316s-0.112 -0.055 -0.118 -0.245c-0.004 -0.135 0.089 -0.224 0.089 -0.224s-0.038 -0.122 0.042 -0.236 0.152 -0.11 0.152 -0.11 0 -0.144 0.122 -0.22 0.22 -0.004 0.22 -0.004 0.051 -0.122 0.186 -0.131 0.177 0.072 0.177 0.072 0.089 -0.118 0.22 -0.08 0.152 0.144 0.152 0.144 0.114 -0.106 0.253 -0.013 0.106 0.215 0.106 0.215 0.139 -0.068 0.27 0.063c0.097 0.097 0.038 0.224 0.038 0.224s0.126 0.007 0.177 0.148c0.051 0.14 -0.055 0.241 -0.055 0.241s0.126 0.014 0.16 0.169c0.038 0.169 -0.093 0.266 -0.093 0.266s0.076 0.068 0.051 0.241c-0.022 0.151 -0.177 0.211 -0.177 0.211s0.059 0.104 -0.017 0.239c-0.076 0.135 -0.236 0.128 -0.236 0.128s-0.01 0.095 -0.08 0.165c-0.089 0.089 -0.211 0.051 -0.211 0.051L1.392 1.594z'
				fill='#ffeac9'
			/>
			<path
				d='m2.443 2.034 0.431 0.361L2.988 2.49s0.122 -0.004 0.207 -0.127c0.06 -0.087 0.017 -0.207 0.017 -0.207s0.152 -0.021 0.199 -0.194c0.046 -0.173 -0.038 -0.253 -0.038 -0.253s0.124 -0.038 0.124 -0.211c0 -0.158 -0.142 -0.19 -0.142 -0.19s0.133 -0.049 0.089 -0.194c-0.039 -0.129 -0.173 -0.122 -0.173 -0.122s0.078 -0.135 -0.021 -0.249c-0.084 -0.097 -0.203 -0.042 -0.203 -0.042s0.021 -0.122 -0.068 -0.194 -0.199 -0.017 -0.199 -0.017 0.004 -0.127 -0.101 -0.156 -0.16 0.025 -0.16 0.025 -0.063 -0.097 -0.169 -0.089 -0.148 0.085 -0.148 0.085 -0.063 -0.076 -0.177 -0.051c-0.121 0.027 -0.127 0.135 -0.127 0.135s-0.098 -0.048 -0.177 0c-0.106 0.063 -0.089 0.186 -0.089 0.186s-0.118 0.017 -0.165 0.101c-0.061 0.111 -0.004 0.22 -0.004 0.22l0.017 0.291z'
				fill='#4d4d4d'
			/>
			<path
				d='M2.938 2.384s0.118 -0.013 0.152 -0.114 -0.013 -0.169 -0.013 -0.169 0.152 -0.046 0.186 -0.186 -0.055 -0.245 -0.055 -0.245 0.148 -0.152 0.089 -0.3 -0.19 -0.181 -0.19 -0.181 0.077 -0.15 0.03 -0.245c-0.068 -0.135 -0.245 -0.127 -0.245 -0.127s0.046 -0.142 -0.115 -0.229c-0.14 -0.076 -0.26 0.011 -0.26 0.011s-0.068 -0.142 -0.228 -0.142 -0.215 0.148 -0.215 0.148 -0.135 -0.089 -0.262 -0.013 -0.122 0.224 -0.122 0.224 -0.148 -0.008 -0.262 0.14c-0.088 0.114 -0.034 0.321 -0.034 0.321L0.978 1.603s-0.006 -0.056 -0.038 -0.114 0.077 -0.396 0.077 -0.396 -0.5 0.222 -0.563 0.337c-0.063 0.114 -0.108 0.312 -0.097 0.507 0.015 0.264 0.16 0.655 0.443 0.862 0.314 0.23 0.598 0.344 1.043 0.338 0.574 -0.008 0.836 -0.16 0.908 -0.19s0.186 -0.562 0.186 -0.562'
				fill='#845b52'
			/>
			<radialGradient
				id='IconifyId17ecdb2904d178eab21239'
				cx='25.863'
				cy='20.345'
				r='14.778'
				gradientTransform='matrix(.8012 -.5985 .5116 .6849 -5.267 21.888)'
				gradientUnits='userSpaceOnUse'
			>
				<stop offset='.206' stopColor='#5ea4ce' />
				<stop offset='.506' stopColor='#988aa4' />
				<stop offset='1' stopColor='#fe5d5a' />
			</radialGradient>
			<path
				d='M0.898 1.214s0.152 -0.135 0.199 -0.199c0.046 -0.063 0.154 -0.224 0.118 -0.494 -0.029 -0.224 -0.244 -0.347 -0.411 -0.31 -0.093 0.021 -0.21 0.234 -0.227 0.301s0.089 0.342 0.089 0.342z'
				fill='url(#IconifyId17ecdb2904d178eab21239)'
			/>
			<path
				cx='29.36'
				cy='19.23'
				rx='3.66'
				ry='3.8'
				fill='#000306'
				d='M0.991 0.577A0.11 0.114 0 0 1 0.881 0.691A0.11 0.114 0 0 1 0.771 0.577A0.11 0.114 0 0 1 0.991 0.577z'
			/>
			<path
				d='M0.513 0.475c-0.034 0.046 -0.076 0.101 -0.118 0.144 -0.063 0.063 -0.131 0.135 -0.127 0.16 0.007 0.039 0.08 0.012 0.127 -0.013 0.089 -0.046 0.14 -0.068 0.169 -0.068 0.03 0 0.042 0.021 0.068 0.004s0.063 -0.089 0.059 -0.114 -0.108 -0.063 -0.13 -0.076c-0.021 -0.013 -0.048 -0.038 -0.048 -0.038'
				fill='#898484'
			/>
			<path
				d='M0.826 0.204c0.026 0.006 -0.093 0.058 -0.122 0.185 -0.026 0.112 -0.055 0.22 -0.148 0.173 -0.124 -0.062 -0.032 -0.236 0.004 -0.276 0.051 -0.056 0.148 -0.11 0.266 -0.082'
				fill='#a22911'
			/>
			<path
				d='M0.692 0.604c-0.004 -0.046 -0.057 -0.025 -0.065 0.021s-0.015 0.064 -0.032 0.096c-0.017 0.032 -0.19 0.181 -0.22 0.223s-0.091 0.14 -0.038 0.23c0.046 0.078 0.207 0.055 0.207 0.055l0.194 -0.275s-0.03 -0.106 -0.034 -0.151c-0.004 -0.046 -0.008 -0.151 -0.013 -0.197'
				fill='#a22911'
			/>
			<path
				d='M0.853 0.926c0.077 0.094 0.084 0.2 0.07 0.284 -0.014 0.084 -0.056 0.271 -0.238 0.424 -0.094 0.079 -0.289 0.129 -0.401 0.012 -0.133 -0.139 0.091 -0.328 0.125 -0.374s0.175 -0.16 0.221 -0.272c0.028 -0.069 0.07 -0.214 0.07 -0.214s0.091 0.066 0.152 0.141'
				fill='#ff2219'
			/>
			<path
				d='M2.836 2.262s0.099 -0.024 0.13 -0.093c0.039 -0.09 -0.006 -0.152 -0.006 -0.152s0.16 -0.022 0.175 -0.177c0.011 -0.122 -0.082 -0.183 -0.082 -0.183s0.112 -0.079 0.093 -0.203c-0.026 -0.163 -0.18 -0.169 -0.18 -0.169s0.127 -0.098 0.028 -0.251c-0.063 -0.097 -0.214 -0.07 -0.214 -0.07s0.056 -0.138 -0.076 -0.211c-0.127 -0.07 -0.236 0.042 -0.236 0.042s0.003 -0.142 -0.169 -0.158c-0.149 -0.014 -0.194 0.138 -0.194 0.138s-0.098 -0.09 -0.234 -0.025c-0.124 0.059 -0.112 0.203 -0.112 0.203s-0.131 -0.027 -0.217 0.051c-0.09 0.082 -0.058 0.248 -0.058 0.248S0.877 1.583 0.843 1.62s-0.239 0.329 -0.107 0.673S1.236 2.808 1.575 2.617c0.234 -0.132 0.388 -0.442 0.456 -0.538 0.068 -0.096 0.158 -0.121 0.158 -0.121z'
				fill='#b79277'
			/>
			<path
				d='M1.93 2.011s0.189 -0.025 0.349 0.051 0.338 0.228 0.419 0.408 0.073 0.467 0.073 0.467 0.256 0.014 0.265 -0.245c0.006 -0.18 -0.082 -0.262 -0.082 -0.262s0.073 -0.093 -0.048 -0.239c-0.072 -0.087 -0.193 -0.13 -0.193 -0.13s-0.09 -0.112 -0.279 -0.15c-0.253 -0.05 -0.505 0.1 -0.505 0.1'
				fill='#faeacb'
			/>
			<path
				d='M1.566 1.237s0.013 -0.142 0.141 -0.186c0.163 -0.056 0.248 0.037 0.248 0.037s0.076 -0.155 0.265 -0.144c0.209 0.013 0.241 0.22 0.241 0.22s0.186 -0.05 0.295 0.116 -0.004 0.337 -0.004 0.337 0.155 0.046 0.152 0.232c-0.003 0.176 -0.106 0.252 -0.106 0.252s-0.046 -0.028 -0.08 -0.03c-0.032 -0.018 -0.217 -0.162 -0.388 -0.165 -0.172 -0.003 -0.318 0.062 -0.4 0.104s-0.394 0.27 -0.442 0.298 -0.366 0.228 -0.597 -0.065 -0.067 -0.661 0.068 -0.783c0.152 -0.138 0.361 -0.222 0.608 -0.225'
				fill='#4d4d4d'
			/>
			<path
				d='M1.31 1.718c0.01 0.038 0.096 0.132 0.331 0.214 0.091 0.032 0.289 0.078 0.289 0.078s0.116 -0.051 0.188 -0.075c0.024 -0.008 0.165 -0.032 0.165 -0.032 0.025 0.009 -0.312 -0.034 -0.53 -0.091 -0.188 -0.048 -0.458 -0.152 -0.443 -0.093'
				fill='#000306'
			/>
			<path
				d='M2.745 2.621s0.052 -0.015 0.144 -0.01c0.074 0.004 0.148 0.015 0.15 0.057s-0.068 0.025 -0.158 0.025c-0.089 0 -0.123 0.011 -0.123 0.011z'
				fill='#b49075'
			/>
			<path
				d='M2.67 2.42s0.082 -0.014 0.136 -0.018 0.167 -0.001 0.167 -0.041 -0.138 -0.046 -0.192 -0.042c-0.076 0.006 -0.161 0.024 -0.161 0.024z'
				fill='#b49075'
			/>
			<path
				d='M2.504 2.214s0.056 -0.06 0.138 -0.068c0.077 -0.007 0.191 0.004 0.17 -0.037s-0.13 -0.047 -0.179 -0.043c-0.162 0.011 -0.204 0.089 -0.204 0.089z'
				fill='#b49075'
			/>
		</svg>
	);
};
